import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getPostDetail, getShareQuiz } from "../../api";
import { toast } from "react-toastify";
import styled from "styled-components";
import { handleError } from "../../utils/commonFunction";
import { useAuth } from "../../context/Auth";
import CircularComponent from "../process/CircularComponent";
import { useTranslation } from "react-i18next";
import QuizDetailItem from "./QuizDetailItem";
import { WIDTH } from "../../theme/constants";

const Wrapper = styled.div`
  // padding: 0 16px;
  margin: 0 auto;
  max-width: 632px;
  width: 100%;

  @media screen and (min-width: ${WIDTH.desktop}) {
    padding: 0;
    margin-left: 100px;
    max-width: 600px;
  }
`;

const HeightWhenEmpty = styled.div`
  display: flex;
  align-items: center;
  height: calc(100vh - 230px);
  position: relative;
`;

function QuizDetail() {
  const params = useParams();
  const { logout } = useAuth();
  const { state: locationState } = useLocation();
  const [post, setPost] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleGetDetail = async () => {
    try {
      setIsLoading(true);
      const res = await getPostDetail(params.id);
      setPost(res);
    } catch (error) {
      handleError(error, logout, navigate);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    params.id && handleGetDetail();
  }, [params.id]);

  if (isLoading)
    return (
      <HeightWhenEmpty>
        <CircularComponent />
      </HeightWhenEmpty>
    );

  return <Wrapper>{post && <QuizDetailItem post={post} fetchData={handleGetDetail} />}</Wrapper>;
}

export default QuizDetail;
